import { type MaintenanceChecklistField } from '@gb-ticket/shared-types';

import { Input } from '@/components/ui/input';
import { ChecklistFieldShell } from '@/products/maintenance/features/protocol-renderer/checklist-field-shell';

type NumberField = Extract<
  MaintenanceChecklistField,
  { type: 'integer' } | { type: 'decimal' } | { type: 'measurement' }
>;

type Props = {
  field: NumberField;
  readOnly?: boolean;
};

export function ChecklistNumberField({ field, readOnly = true }: Props) {
  const placeholder = field.type === 'measurement' ? field.unit : undefined;
  return (
    <ChecklistFieldShell field={field}>
      <Input type="number" disabled={readOnly} placeholder={placeholder} />
    </ChecklistFieldShell>
  );
}
